export function titleText(title) {
    let fixTitle = ''
    switch (title) {
        case '/dashboard':
            fixTitle = 'Dashboard'
            break;
        case 'masterdata/building':
            fixTitle = 'Gedung'
            break;
        case 'masterdata/room':
            fixTitle = 'Ruangan'
            break;
        case 'masterdata/fasilitas':
            fixTitle = 'Fasilitas'
            break;
        case 'masterdata/sub-fasilitas':
            fixTitle = 'Sub Fasilitas'
            break;
        case 'masterdata/loket':
            fixTitle = 'Loket'
            break;
        case 'masterdata/poli':
            fixTitle = 'Poliklinik'
            break;
        case 'masterdata/dokter':
            fixTitle = 'Dokter'
            break;
        case 'masterdata/skrining':
            fixTitle = 'Skrining'
            break;
        case 'masterdata/tambah-skrining':
            fixTitle = 'Tambah Skrining'
            break;
        case 'masterdata/detail-skrining':
            fixTitle = 'Detail Skrining'
            break;
        case 'masterdata/akun':
            fixTitle = 'Akun'
            break;
        case 'masterdata/pasien':
            fixTitle = 'Pasien'
            break;
        case 'masterdata/kategori-faq':
            fixTitle = 'Kategori FAQ'
            break;
        case 'masterdata/ambulance':
            fixTitle = 'Ambulance'
            break;
        case 'masterdata/asuransi':
            fixTitle = 'Asuransi'
            break;
        case 'schedule/jadwal-fasilitas':
            fixTitle = 'Master Jadwal Fasilitas'
            break;
        case 'masterdata/tambah-jadwal-fasilitas':
            fixTitle = 'Tambah Master Jadwal Fasilitas'
            break;
        case 'schedule/detail-jadwal-fasilitas':
            fixTitle = 'Detail Master Jadwal Fasilitas'
            break;
        case 'schedule/jadwal-poli':
            fixTitle = 'Master Jadwal Poliklinik'
            break;
        case 'masterdata/tambah-jadwal-poliklinik':
            fixTitle = 'Tambah Jadwal Klinik'
            break;
        case 'schedule/detail-jadwal-poli':
            fixTitle = 'Detail Master Jadwal Klinik'
            break;
        case 'schedule/jadwal-dokter':
            fixTitle = 'Master Jadwal Dokter'
            break;
        case 'masterdata/tambah-jadwal':
            fixTitle = 'Tambah Jadwal Dokter'
            break;
        case 'masterdata/detail-Jadwal-dokter':
            fixTitle = 'Detail Master Jadwal Dokter'
            break;
        case 'schedule/jadwal-poliklinik':
            fixTitle = 'Jadwal Poliklinik'
            break;
        case 'schedule/tambah-jadwal-poliklinik':
            fixTitle = 'Tambah Jadwal Klinik'
            break;
        case 'schedule/jadwal-transaksi-dokter':
            fixTitle = 'Jadwal Dokter'
            break;
        case 'schedule/tambah-jadwal-dokter':
            fixTitle = 'Tambah Jadwal Dokter'
            break;
        case 'schedule/edit-jadwal-dokter':
            fixTitle = 'Detail Jadwal Dokter'
            break;
        case 'schedule/draft-master-jadwal-dokter':
            fixTitle = 'Draft Master Jadwal Dokter'
            break;
        case 'schedule/draft-master-jadwal':
            fixTitle = 'Draft Master Jadwal Dokter'
            break;
        case 'schedule/download-jadwal-dokter':
            fixTitle = 'Download Jadwal Dokter'
            break;
        case 'dokter/reservasi-dokter':
            fixTitle = 'Reservasi'
            break;
        case 'dokter/detail-reservasi-dokter':
            fixTitle = 'Detail Reservasi'
            break;
        case 'dokter/daftar-reservasi':
            fixTitle = 'Daftar Reservasi'
            break;
        case 'dokter/history-reservasi':
            fixTitle = 'Riwayat Reservasi'
            break;
        case 'dokter/start-hold-stop':
            fixTitle = 'Kelola Sesi'
            break;
        case 'dokter/pemanggilan-dokter':
            fixTitle = 'Panggilan Antrian'
            break;
        case 'dokter/detail-pemanggilan':
            fixTitle = 'Detail Pemanggilan'
            break;
        case 'dokter/riwayat-panggilan':
            fixTitle = 'Riwayat Panggilan Antrian'
            break;
        case 'dokter/catatan':
            fixTitle = 'Catatan Dokter'
            break;
        case 'skrining/pemanggilan-skrining':
            fixTitle = 'Monitoring Skrining'
            break;
        case 'skrining/riwayat-skrining':
            fixTitle = 'Riwayat Skrining'
            break;
        case 'transaksi/detail-riwayat-skrining-pasien':
            fixTitle = 'Detail Riwayat Skrining Pasien'
            break;
        case 'registrasi-umum/start-hold-stop':
            fixTitle = 'Kelola Sesi'
            break;
        case 'registrasi-umum/pemanggilan-registrasi-umum':
            fixTitle = 'Panggilan Antrian'
            break;
        case 'registrasi-umum/pemanggilan-registrasi':
            fixTitle = 'Pemanggilan Registrasi Umum'
            break;
        case 'registrasi-umum/riwayat':
            fixTitle = 'Riwayat Panggilan Antrian'
            break;
        case 'registrasi-asuransi/start-hold-stop':
            fixTitle = 'Kelola Sesi'
            break;
        case 'registrasi-asuransi/pemanggilan-registrasi-asuransi':
            fixTitle = 'Panggilan Antrian'
            break;
        case 'registrasi-asuransi/pemanggilan-registrasi':
            fixTitle = 'Pemanggilan Registrasi Asuransi'
            break;
        case 'registrasi-asuransi/riwayat':
            fixTitle = 'Riwayat Panggilan Antrian'
            break;
        case 'registrasi-bpjs/start-hold-stop':
            fixTitle = 'Kelola Sesi'
            break;
        case 'registrasi-bpjs/pemanggilan-registrasi-bpjs':
            fixTitle = 'Panggilan Antrian'
            break;
        case 'registrasi-bpjs/pemanggilan-registrasi':
            fixTitle = 'Pemanggilan Registrasi BPJS'
            break;
        case 'registrasi-bpjs/riwayat':
            fixTitle = 'Riwayat Panggilan Antrian'
            break;
        case 'transaksi/start-hold-stop':
            fixTitle = 'Kelola Sesi'
            break;
        case 'transaksi/pemanggilan':
            fixTitle = 'Panggilan Antrian'
            break;
        case 'transaksi/pemanggilan-transaksi':
            fixTitle = 'Pemanggilan Transaksi'
            break;
        case 'transaksi/riwayat':
            fixTitle = 'Riwayat Panggilan Antrian'
            break;
        case 'kasir/start-hold-stop':
            fixTitle = 'Kelola Sesi'
            break;
        case 'kasir/pemanggilan':
            fixTitle = 'Panggilan Antrian'
            break;
        case 'kasir/pemanggilan-verifikasi':
            fixTitle = 'Pemanggilan Kasir'
            break;
        case 'kasir/riwayat':
            fixTitle = 'Riwayat Panggilan Antrian'
            break;
        case 'penyerahan-bpjs/start-hold-stop':
            fixTitle = 'Kelola Sesi'
            break;
        case 'penyerahan-bpjs/pemanggilan-penyerahan-bpjs':
            fixTitle = 'Panggilan Antrian'
            break;
        case 'registrasi-bpjs/pemanggilan-registrasi':
            fixTitle = 'Pemanggilan Registrasi BPJS'
            break;
        case 'penyerahan-bpjs/riwayat':
            fixTitle = 'Riwayat Panggilan Antrian'
            break;
        case 'farmasi/farmasi-dalam':
            fixTitle = 'Monitoring Farmasi Dalam'
            break;
        case 'farmasi/farmasi-dalam-list':
            fixTitle = 'Pemanggilan Farmasi Dalam'
            break;
        case 'farmasi/riwayat':
            fixTitle = 'Riwayat Farmasi Dalam'
            break;
        case 'farmasi/kelola-loket':
            fixTitle = 'Kelola Sesi'
            break;
        case 'farmasi/pemanggilan-farmasi':
            fixTitle = 'Panggilan Antrian'
            break;
        case 'farmasi/pemanggilan':
            fixTitle = 'Pemanggilan Farmasi'
            break;
        case 'farmasi/riwayat-panggilan':
            fixTitle = 'Riwayat Panggilan Antrian'
            break;
        case 'farmasi/resep':
            fixTitle = 'Monitoring Resep'
            break;
        case 'farmasi/detail-resep':
            fixTitle = 'Detail Monitoring Resep'
            break;
        case 'lab/start-hold-stop':
            fixTitle = 'Kelola Sesi'
            break;
        case 'lab/pemanggilan':
            fixTitle = 'Panggilan Antrian'
            break;
        case 'lab/pemanggilan-verifikasi':
            fixTitle = 'Pemanggilan Lab'
            break;
        case 'lab/riwayat':
            fixTitle = 'Riwayat Panggilan Antrian'
            break;
        case 'lab/monitoring-hasil':
            fixTitle = 'Monitoring Hasil Laboratorium'
            break;
        case 'lab/hasil-lab':
            fixTitle = 'Monitoring Hasil Lab'
            break;
        case 'lab/monitoring-riwayat-hasil':
            fixTitle = 'Monitoring Riwayat Hasil Laboratorium'
            break;
        case 'radiologi/start-hold-stop':
            fixTitle = 'Kelola Sesi'
            break;
        case 'radiologi/pemanggilan-radiologi-verifikasi':
            fixTitle = 'Panggilan Antrian'
            break;
        case 'radiologi/pemanggilan-radiologi':
            fixTitle = 'Pemanggilan Radiologi'
            break;
        case 'radiologi/riwayat':
            fixTitle = 'Riwayat Panggilan Antrian'
            break;
        case 'radiologi/monitoring-hasil':
            fixTitle = 'Monitoring Hasil Radiologi'
            break;
        case 'radiologi/hasil-radiologi':
            fixTitle = 'Monitoring Hasil Radiologi'
            break;
        case 'radiologi/monitoring-riwayat-hasil':
            fixTitle = 'Monitoring Riwayat Hasil Radiologi'
            break;
        case 'report/lead-time-process-doctor':
            fixTitle = 'Lead Time Process Doctor'
            break;
        case 'report/lead-time-process-facility':
            fixTitle = 'Lead Time Process Facility'
            break;
        case 'report/monitor-ruangan':
            fixTitle = 'Monitoring Ruangan'
            break;
        case 'report/lead-time-process-pharmacy':
            fixTitle = 'Lead Time Process Pharmacy'
            break;
        case 'report/monitoring-transaksi':
            fixTitle = 'Monitoring Transaksi'
            break;
        case 'report/appointment-by-doctor-schedule':
            fixTitle = "Appointment by Doctor's Schedule"
            break;
        case 'report/monitoring-general-consent':
            fixTitle = "Monitoring General Consent"
            break;
        case 'setting/user-role':
            fixTitle = 'User Role'
            break;
        case 'setting/user-management':
            fixTitle = 'User Management'
            break;
        case 'setting/parameter':
            fixTitle = 'Parameter'
            break;
        case 'setting/queue-display':
            fixTitle = 'Queue Display'
            break;
        case 'setting/kiosk':
            fixTitle = 'Kiosk'
            break;
        case 'setting/running-text':
            fixTitle = 'Running Text'
            break;
        case 'setting/faq':
            fixTitle = 'FAQ'
            break;
        case 'setting/tambah-faq':
            fixTitle = 'Input - FAQ'
            break;
        case 'setting/edit-faq':
            fixTitle = 'Edit - FAQ'
            break;
        case 'setting/tnc':
            fixTitle = 'Terms & Condition'
            break;
        case 'setting/tambah-tnc':
            fixTitle = 'Input - TNC'
            break;
        case 'setting/edit-tnc':
            fixTitle = 'Edit - TNC'
            break;
        case 'setting/privacy-policy':
            fixTitle = 'Privacy Policy'
            break;
        case 'setting/tambah-pp':
            fixTitle = 'Input - Pivacy Policy'
            break;
        case 'setting/edit-pp':
            fixTitle = 'Edit - Privacy Policy'
            break;
        case 'setting/promosi':
            fixTitle = 'Promosi'
            break;
        case 'setting/tambah-promosi':
            fixTitle = 'Input - Promosi'
            break;
        case 'setting/edit-promosi':
            fixTitle = 'Edit - Promosi'
            break;
        case 'setting/tv-media-display':
            fixTitle = 'TV Media Display'
            break;
        case 'setting/libur-nasional':
            fixTitle = 'Libur Nasional'
            break;
        case 'registrasi/start-hold-stop':
            fixTitle = 'Kelola Sesi'
            break;
        case 'registrasi/pemanggilan-registrasi':
            fixTitle = 'Panggilan Antrian'
            break;
        case 'registrasi/pemanggilan-all-registrasi':
            fixTitle = 'Pemanggilan Registrasi'
            break;
        case 'registrasi/riwayat':
            fixTitle = 'Riwayat Panggilan Antrian'
            break;
        case 'emergency/active-order':
            fixTitle = 'Active Orde'
            break;
        case 'emergency/add-emergency':
            fixTitle = 'Input Pesanan - Emergency'
            break;
        case 'emergency/detail-emergency':
            fixTitle = 'Edit Pesanan - Emergency'
            break;
        case 'emergency/riwayat':
            fixTitle = 'Riwayat'
            break;
        case 'emergency/master-emergency-officer':
            fixTitle = 'Master Petugas Emergency'
            break;
        case 'telemedicine/monitoring-transaksi-order-telemedicine':
            fixTitle = 'Monitoring Transaksi Order'
            break;
        case 'telemedicine/monitoring-reservasi-telemedicine':
            fixTitle = 'Monitoring Reservasi'
            break;
        case 'telemedicine/monitoring-biaya-telemedicine':
            fixTitle = 'Monitoring Biaya'
            break;
        case 'telemedicine/master-doctor-telemedicine':
            fixTitle = 'Master Dokter Telekonsultasi'
            break;
        case 'telemedicine/master-harga-telemedicine':
            fixTitle = 'Master Harga Telekonsultasi'
            break;
        case 'telemedicine/master-jadwal-telemedicine':
            fixTitle = 'Master Jadwal Telekonsultasi'
            break;
        case 'telemedicine/jadwal-telemedicine':
            fixTitle = 'Jadwal Telekonsultasi'
            break;
        case 'telemedicine/master-specialty-telemedicine':
            fixTitle = 'Master Spesialisasi Telekonsultasi'
            break;
        case 'upload/appointment':
            fixTitle = 'Upload Appointment'
            break;
        case 'lain-lain/ulasan':
            fixTitle = 'Ulasan'
            break;
        case 'lain-lain/masukan':
            fixTitle = 'Masukan'
            break;
        case 'pembayaran/monitoring':
            fixTitle = 'Monitoring Pembayaran'
            break;
        case 'pembayaran/detail-tagihan':
            fixTitle = 'Pembayaran - Input Tagihan'
            break;
        case 'pembayaran/detail-tagihan-non-reservasi-farmasi':
            fixTitle = 'Pembayaran Farmasi - Input Tagihan Tanpa Reservasi'
            break;
        case 'pembayaran/detail-tagihan-non-reservasi-lab':
            fixTitle = 'Pembayaran Laboratorium - Input Tagihan Tanpa Reservasi'
            break;
        case 'pembayaran/detail-tagihan-non-reservasi-radiologi':
            fixTitle = 'Pembayaran Radiologi - Input Tagihan Tanpa Reservasi'
            break;
        case 'pembayaran/detail-monitoring':
            fixTitle = 'Detail Pembayaran'
            break;
        case 'pembayaran/riwayat-pembayaran':
            fixTitle = 'Riwayat Pembayaran'
            break;
        case 'transaksi/detail-riwayat':
            fixTitle = 'Detail Pembayaran'
            break;
        case 'transaksi-campuran/kelola-sesi':
            fixTitle = 'Kelola Sesi'
            break;
        case 'transaksi-campuran/panggilan-antrian':
            fixTitle = 'Panggilan Antrian'
            break;
        // case 'registrasi/pemanggilan-all-registrasi':
        //     fixTitle = 'Pemanggilan Registrasi'
        //     break;
        case 'transaksi-campuran/riwayat-panggilan-antrian':
            fixTitle = 'Riwayat Panggilan Antrian'
            break;

        default:
    }
    return fixTitle
}